<template>
  <v-dialog
    :value="type == 1 ? dialogoMora : dialogoMoraAvalado"
    width="460px"
    transition="dialog-top-transition"
    @click:outside="mostrarDialogoMora({ val: false, type })"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card height="100%">
      <v-toolbar color="primary" dense dark class="d-flex justify-center">
        <span class="titulo titulo-local"> {{ titulo }} </span>
      </v-toolbar>
      <v-card-text class="mt-4 pb-0" style="font-size: 18px">
        <p style="text-align: justify">
          {{ type == 1 ? userLogged.msg_mora : userLogged.msg_mora_avalado }}
        </p>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="error" @click="mostrarDialogoMora({ val: false, type })"
          >Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
import auth from "@/services/auth";
import conv from "@/utility/conversores";

export default {
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data: function () {
    return {
      userLogged: auth.getUserLogged(),
      conv
    };
  },
  computed: {
    ...mapState(["dialogoMora", "dialogoMoraAvalado"]),
    titulo() {
      return this.type == 1
        ? "Aviso de Mora"
        : "Aviso de Crédito Avalado en Mora";
    }
  },
  methods: {
    ...mapActions(["mostrarDialogoMora"])
  }
};
</script>

<style scoped>
.titulo-local {
  font-weight: 300;
  font-size: 22px;
  line-height: 28px;
}
</style>
